(function() {
  'use strict';

  var bar = document.getElementById('th-reading-progress');
  if (!bar) return;

  var fill = bar.querySelector('.th-reading-progress__fill');
  if (!fill) return;

  var ticking = false;
  var lastPct = -1;

  function calculate() {
    var scrolled = window.pageYOffset || document.documentElement.scrollTop || 0;
    var docHeight = (document.documentElement.scrollHeight || document.body.scrollHeight) - window.innerHeight;

    if (docHeight <= 0) {
      return 0;
    }

    var pct = scrolled / docHeight;
    if (pct < 0) pct = 0;
    if (pct > 1) pct = 1;
    return pct;
  }

  function update() {
    var pct = calculate();
    if (pct !== lastPct) {
      fill.style.width = (pct * 100).toFixed(2) + '%';
      lastPct = pct;
    }
    ticking = false;
  }

  function requestUpdate() {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);
  window.addEventListener('load', update);

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    update();
  } else {
    document.addEventListener('DOMContentLoaded', update);
  }
})();